module.exports = __webpack_public_path__ + "img/icon-map-implantation-07.dd12bf1e.svg";